import type { IconData } from '@stacksjs/iconify-core'

export const circleLayer: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M15 2a7 7 0 0 0-6.88 5.737a6 6 0 0 1 8.143 8.143A6.997 6.997 0 0 0 15 2\" opacity=\".25\"/><circle cx=\"7\" cy=\"17\" r=\"5\" fill=\"currentColor\"/><path fill=\"currentColor\" d=\"M11 7a6 6 0 0 0-5.97 5.406a4.997 4.997 0 0 1 6.564 6.564A6 6 0 0 0 11 7\" opacity=\".5\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default circleLayer
